<template>
  <div>
    <div v-bind:data-kt-indicator="loading ? 'on' : 'off'">
      <span class="indicator-progress">
        Aguarde, carregando...
        <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
      </span>
    </div>
    <div
      v-if="this.errosGerais.Message && !loading"
      class="notice d-flex bg-light-danger rounded border-danger border border-dashed mb-9 p-6 me-lg-10"
      ref="errosGerais"
    >
      <span class="svg-icon svg-icon-2tx svg-icon-danger me-4">
        <inline-svg src="media/icons/duotune/general/gen044.svg" />
      </span>
      <div class="d-flex flex-stack flex-grow-1">
        <div class="fw-bold">
          <h4 class="text-gray-800 fw-bolder">Aviso</h4>
          <div class="fs-6 text-gray-600">
            {{ this.errosGerais.Message }}
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex flex-column flex-xl-row">
      <div class="flex-column flex-lg-row-auto mb-7 me-lg-10 w-100 w-xl-400px">
        <div class="card card-flush py-5">
          <div class="card-header">
            <div class="card-title">
              <img src="media/icons/duotune/graphs/gra012.svg" class="me-2" />
              <h2>Relatórios</h2>
            </div>
            <div class="card-title">
              <div class="d-flex align-items-center position-relative my-1">
                <span class="svg-icon svg-icon-1 position-absolute ms-6">
                  <inline-svg src="media/icons/duotune/general/gen004.svg" />
                </span>
                <input
                  type="text"
                  id="txtPesquisar"
                  v-model="pesquisa"
                  @input="onSearch($event.target.value)"
                  class="form-control form-control-solid w-100 ps-15"
                  placeholder="Pesquisar Relatório"
                />
              </div>
            </div>
          </div>
          <div class="card-body pt-0">
            <div
              v-if="loading"
              class="overlay-layer card-rounded bg-dark bg-opacity-5"
            >
              <div class="spinner-border text-primary" role="status"></div>
              <span class="ms-2">Aguarde, carregando...</span>
            </div>
            <div v-else class="custom-tree-container border p-2">
              <el-tree
                class="custom-tree"
                ref="treeRelatorios"
                :data="this.relatorios"
                :expand-on-click-node="false"
                :filter-node-method="filterNode"
                :empty-text="emptyText"
                :highlight-current="true"
                default-expand-all
                @node-click="selecionarRegistro($event)"
              >
                <template #default="{ data, node }">
                  <div
                    class="prevent-select"
                    @dblclick="carregarRelatorio(this.relatorioAtual.id)"
                  >
                    <span
                      v-if="data.modulo"
                      class="svg-icon svg-icon-1 me-3 svg-icon-warning"
                    >
                      <inline-svg src="media/icons/duotune/files/fil012.svg"
                    /></span>
                    <span v-else class="svg-icon svg-icon-1 me-3">
                      <inline-svg src="media/icons/duotune/files/fil003.svg"
                    /></span>
                    <span class="custom-tree-node">
                      <span>{{ node.label }}</span>
                    </span>
                  </div>
                </template>
              </el-tree>
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex flex-column flex-row-fluid gap-6 mb-7 gap-lg-10">
        <div class="card card-flush p-5">
          <div
            v-if="
              this.relatorioAtual &&
              this.relatorioAtual.id &&
              this.relatorioAtual.id > 0
            "
            class="card-body p-2"
          >
            <div class="d-flex flex-wrap flex-sm-nowrap mb-3">
              <div class="flex-grow-1">
                <div
                  class="d-flex justify-content-between align-items-start flex-wrap mb-2"
                >
                  <div class="d-flex flex-column mb-4">
                    <div class="fw-bold">
                      <div class="text-gray-800 fw-bolder">
                        {{ this.relatorioAtual.label }}
                      </div>
                      <p class="fs-7 quebra-texto text-gray-600 mt-2">
                        {{ this.relatorioAtual.descricao }}
                      </p>
                    </div>
                  </div>
                  <div
                    class="d-flex flex-wrap flex-row-fluid justify-content-end gap-5"
                  >
                    <button
                      class="btn btn-primary svg-icon-white"
                      @click="this.carregarRelatorio(this.relatorioAtual.id)"
                    >
                      <span class="svg-icon svg-icon-1">
                        <inline-svg
                          src="media/icons/duotune/arrows/arr027.svg"
                          class="me-2"
                        />Executar
                      </span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            v-else
            class="notice d-flex bg-light-info rounded border-info border border-dashed my-5 p-6"
          >
            <span class="svg-icon svg-icon-2tx svg-icon-info me-4">
              <inline-svg src="media/icons/duotune/general/gen044.svg" />
            </span>
            <div class="d-flex flex-stack flex-grow-1">
              <div class="fw-bold">
                <div class="text-gray-800 fw-bolder">
                  Nenhum relatório selecionado
                </div>
                <div class="fs-7 text-gray-600 mt-2">
                  Selecione um relatório para visualizar
                </div>
              </div>
            </div>
          </div>
          <div
            class="hover-scroll-x"
            v-if="this.relatoriosAbertos && relatoriosAbertos.length > 0"
          >
            <div class="d-grid p-0">
              <ul class="nav nav-tabs flex-nowrap text-nowrap">
                <li
                  v-for="relatorioAberto in relatoriosAbertos"
                  :key="relatorioAberto.guid"
                  class="nav-item position-relative d-flex align-items-center"
                  :ref="'nav' + relatorioAberto.guid"
                >
                  <a
                    @click="selecionarAba(relatorioAberto)"
                    :class="[
                      'nav-link btn btn-active-light btn-color-gray-600 btn-active-color-primary rounded-bottom-0',
                      {
                        active:
                          relatorioAberto.guid === this.relatorioAberto.guid,
                      },
                    ]"
                  >
                    {{ relatorioAberto.label }}
                    <button
                      @click="fecharAba(relatorioAberto)"
                      type="button"
                      class="btn-close ms-2"
                      aria-label="Close"
                    ></button>
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div class="tab-content" ref="tabContent">
            <div
              v-for="relatorioAberto in relatoriosAbertos"
              :key="relatorioAberto.guid"
              class="tab-pane fade"
              :class="{
                'show active':
                  relatorioAberto.guid === this.relatorioAberto.guid,
              }"
              :id="relatorioAberto.guid"
              role="tabpanel"
            >
              <div class="p-2 bg-light">
                <div class="d-flex flex-wrap gap-1">
                  <button
                    :ref="'btnImprimir' + relatorioAberto.guid"
                    type="button"
                    class="btn btn-sm btn-active-secondary"
                    @click="this.imprimir(relatorioAberto)"
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    title="Imprimir"
                  >
                    <div class="d-flex flex-wrap">
                      <i class="fas fa-print fs-4 p-0"></i>
                    </div>
                  </button>
                  <button
                    type="button"
                    class="btn btn-sm btn-active-secondary"
                    @click="enviarEmail(relatorioAberto)"
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    title="Enviar por e-mail"
                  >
                    <div class="d-flex flex-wrap">
                      <i class="fas fa-envelope fs-4 p-0"></i>
                    </div>
                  </button>
                  <button
                    type="button"
                    class="btn btn-sm btn-active-secondary"
                    @click="download(relatorioAberto)"
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    title="Download"
                  >
                    <div class="d-flex flex-wrap">
                      <i class="fas fa-download fs-4 p-0"></i>
                    </div>
                  </button>
                </div>
              </div>
              <div class="card-body view-pdf card-scroll" ref="pdfEmbed">
                <div class="vue-pdf-embed">
                  <vue-pdf-embed
                    :ref="'pdfViewer' + relatorioAberto.guid"
                    :width="relatorioAberto.width"
                    :source="relatorioAberto.pdf"
                  />
                </div>
              </div>
              <div class="card-footer border-0 p-0 mt-5">
                <div class="d-flex flex-wrap gap-1">
                  <button
                    type="button"
                    class="btn btn-sm btn-active-secondary"
                    @click="zoom(100, relatorioAberto)"
                  >
                    <i class="fas fa-search-plus fs-4 p-0"></i>
                  </button>
                  <button
                    type="button"
                    class="btn btn-sm btn-active-secondary"
                    @click="zoom(-100, relatorioAberto)"
                  >
                    <i class="fas fa-search-minus fs-4 p-0"></i>
                  </button>
                  <button
                    type="button"
                    class="btn btn-sm btn-active-secondary"
                    @click="zoom(undefined, relatorioAberto)"
                  >
                    <i class="fas fa-file-alt fs-4 p-0"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <LoadingModal
    :nomeRef="'loadingModalExecutarRelatorio'"
    :mensagem="this.mensagemLoading"
    v-if="this.loadingExecutarRelatorio === true"
  ></LoadingModal>
  <LoadingModal
    :nomeRef="'loadingModalCarregarRelatorio'"
    :mensagem="this.mensagemLoadingCarregar"
    v-if="this.loadingCarregarRelatorio === true"
  ></LoadingModal>
  <SendMailModal
    v-if="exibirModalEmail"
    :show="exibirModalEmail"
    :emails="emails"
    :assunto="assuntoEmail"
    :mensagem="mensagemEmail"
    :anexos="anexosEmail"
    @exibirModalMail="exibirModalMail"
  ></SendMailModal>
  <ParametrosConsultaRelatorioModal
    v-if="this.exibirModalFiltro"
    :id="this.relatorioAtual.id"
    :parametros="this.relatorioAtualParametros"
    @exibirParametrosConsultaModal="exibirParametrosConsultaModal"
    @confirmarParametrosConsultaModal="confirmarParametrosConsultaModal"
  ></ParametrosConsultaRelatorioModal>
</template>

<script>
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import { mapState } from "vuex";
import _ from "lodash";
import VuePdfEmbed from "vue-pdf-embed";
import SendMailModal from "@/components/modals/general/SendMailModal";
import {
  hideModal,
  getOrCreateInstanceModal,
  hideModalId,
} from "@/core/helpers/dom";
import LoadingModal from "@/components/modals/general/LoadingModal.vue";
import ParametrosConsultaRelatorioModal from "@/views/relatorios/ParametrosConsultaRelatorioModal.vue";

export default {
  components: {
    LoadingModal,
    VuePdfEmbed,
    SendMailModal,
    ParametrosConsultaRelatorioModal,
  },
  computed: {
    ...mapState("auth", ["user"]),
  },
  methods: {
    scroll(refName) {
      let el = this.$refs[refName];
      if (el) {
        el.scrollIntoView({
          behavior: "smooth",
          block: "center",
          inline: "center",
        });
      }
    },
    async scrollNav(refName) {
      let el = this.$refs[refName];
      if (el) {
        el[0].scrollIntoView({
          behavior: "smooth",
        });
      }
    },
    onSearch(pesquisa) {
      this.$refs.treeRelatorios.filter(pesquisa);
    },
    filterNode(value, data) {
      if (!value) {
        return true;
      } else {
        return data.label
          .toUpperCase()
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
          .includes(
            value
              .toUpperCase()
              .normalize("NFD")
              .replace(/[\u0300-\u036f]/g, "")
          );
      }
    },
    async carregarRelatorios() {
      try {
        this.relatorios = [];

        var ret = await this.$store.dispatch("relatorios/getRelatoriosUsuario");

        if (ret.Success == true) {
          let result = ret.Data;

          const rel = result.map((modulo) => ({
            label: modulo.Modulo,
            modulo: modulo.Modulo,
            children: modulo.Relatorios.map((relatorio) => ({
              label: relatorio.nome,
              id: relatorio.id,
              descricao: relatorio.descricao,
            })),
          }));

          this.relatorios = rel;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async selecionarRegistro(relatorio) {
      this.relatorioAtual = relatorio;
    },
    selecionarAba(relatorio) {
      const index = this.relatoriosAbertos.findIndex(
        (r) => r.guid === relatorio.guid
      );
      if (index !== -1) {
        this.relatorioAberto = { ...relatorio };
      }
    },
    async carregarRelatorio() {
      try {
        if (this.relatorioAtual) {
          this.mensagemLoadingCarregar = "Aguarde, carregando relatório...";
          await this.exibirModalLoadingCarregar(true);

          var retCarregar = await this.$store.dispatch(
            "relatorios/carregarRelatorio",
            "?id=" + this.relatorioAtual.id
          );

          if (retCarregar.Success == true) {
            if (
              retCarregar.Data &&
              retCarregar.Data.parametros &&
              retCarregar.Data.parametros.length > 0
            ) {
              this.relatorioAtualParametros = retCarregar.Data.parametros;
              this.exibirParametrosConsultaModal(true);
            } else {
              await this.exibirModalLoadingCarregar(false);
              await this.executarRelatorio(this.relatorioAtual.id, null);
            }
          }
        }
      } catch (error) {
        console.log(error);
      }
      await this.exibirModalLoadingCarregar(false);
    },

    async executarRelatorio(id, parametros) {
      try {
        if (this.relatorioAtual) {
          this.mensagemLoading = "Aguarde, carregando relatório...";
          await this.exibirModalLoading(true);

          const payload = {
            id: id,
            parametros: parametros,
          };

          var ret = await this.$store.dispatch(
            "relatorios/executarRelatorio",
            payload
          );

          if (ret.Success == true) {
            if (ret.Data.pdfFile.FileContents) {
              let blob = this.$utils.dataToBlob(ret.Data.pdfFile);
              await this.$utils.blobToBase64(blob).then((res) => {
                setTimeout(() => {
                  const relComGuid = {
                    ...this.relatorioAtual,
                    guid: this.$utils.generateUuidv4(),
                    pdf: res,
                    width: undefined,
                  };
                  this.relatoriosAbertos.push(relComGuid);
                  this.relatorioAberto = relComGuid;
                }, 200);

                setTimeout(() => {
                  if (
                    this.relatoriosAbertos &&
                    this.relatoriosAbertos.length === 1
                  ) {
                    this.renderizarRelatorio(this.relatorioAberto);
                  }
                  this.scrollNav("nav" + this.relatorioAberto.guid);
                }, 1000);
              });
            } else {
              await this.$utils.blobToBase64(ret.Data.pdfFile).then((res) => {
                setTimeout(() => {
                  const relComGuid = {
                    ...this.relatorioAtual,
                    guid: this.$utils.generateUuidv4(),
                    pdf: res,
                    width: undefined,
                  };
                  this.relatoriosAbertos.push(relComGuid);
                  this.relatorioAberto = relComGuid;
                }, 200);

                setTimeout(() => {
                  if (
                    this.relatoriosAbertos &&
                    this.relatoriosAbertos.length === 1
                  ) {
                    this.renderizarRelatorio(this.relatorioAberto);
                  }

                  this.scrollNav("nav" + this.relatorioAberto.guid);
                }, 1000);
              });
            }
          }
        }
      } catch (error) {
        console.log(error);
      }
      await this.exibirModalLoading(false);
    },

    fecharAba(relatorio) {
      const index = this.relatoriosAbertos.findIndex(
        (r) => r.guid === relatorio.guid
      );
      if (index !== -1) {
        this.relatoriosAbertos.splice(index, 1);
      }
      if (this.relatoriosAbertos.length > 0) {
        this.relatorioAberto = {
          ...this.relatoriosAbertos[this.relatoriosAbertos.length - 1],
        };
      } else {
        this.relatorioAberto = null;
      }
    },
    async exibirModalLoading(exibir, callback) {
      if (exibir === true) {
        this.loadingExecutarRelatorio = true;
        getOrCreateInstanceModal(
          "loadingModalExecutarRelatorio",
          /*open*/ null,
          /*close*/ null
        );
      } else {
        hideModalId("loadingModalExecutarRelatorio", () => {
          this.loadingExecutarRelatorio = false;
          this.$nextTick(() => {
            if (callback) {
              callback();
            }
          });
        });
      }
    },
    async exibirModalLoadingCarregar(exibir, callback) {
      if (exibir === true) {
        this.loadingCarregarRelatorio = true;
        getOrCreateInstanceModal(
          "loadingModalCarregarRelatorio",
          /*open*/ null,
          /*close*/ null
        );
      } else {
        hideModalId("loadingModalCarregarRelatorio", () => {
          this.loadingCarregarRelatorio = false;
          this.$nextTick(() => {
            if (callback) {
              callback();
            }
          });
        });
      }
    },
    sleep(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
    zoom(valor, relatorio) {
      const pdfViewer = this.$refs["pdfViewer" + relatorio.guid];

      if (pdfViewer) {
        if (relatorio.width === undefined) {
          relatorio.width =
            this.$refs.pdfEmbed[0].getBoundingClientRect().width;
        }
        relatorio.width += parseInt(valor);

        if (relatorio.width <= 0) {
          relatorio.width = undefined;
        }

        if (valor === undefined) {
          relatorio.width = undefined;
        }
      }
    },
    imprimir(relatorio) {
      const pdfViewer = this.$refs["pdfViewer" + relatorio.guid];
      if (pdfViewer) {
        pdfViewer[0].print();
      }
    },
    renderizarRelatorio(relatorio) {
      const pdfViewer = this.$refs["pdfViewer" + relatorio.guid];
      if (pdfViewer) {
        pdfViewer[0].render();
      }
    },
    handleDocumentRender(idx) {
      this.relatoriosAbertos[idx].width =
        this.$refs.pdfEmbed[idx].getBoundingClientRect().width;
    },
    async enviarEmail(relatorio) {
      this.emails = [];
      this.assuntoEmail = relatorio.nome;
      this.mensagemEmail = "";
      this.anexosEmail = [
        { nome: relatorio.guid + ".pdf", base64Arquivo: relatorio.pdf },
      ];
      this.exibirModalMail(true);
    },
    async exibirModalMail(exibir) {
      this.exibirModalEmail = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_send_mail",
          /*open*/ () => {
            this.$utils.requestFocus("kt_modal_send_mail");
          },
          /*close*/ () => {
            this.exibirModalMail(false);
          }
        );
      }
    },
    async download(relatorio) {
      var fileURL = [];
      fileURL = window.URL.createObjectURL(new Blob([relatorio.pdf]), {
        type: "application/pdf",
      });
      var fileLink = document.createElement("a");
      fileLink.href = fileURL;
      fileLink.setAttribute("download", relatorio.guid + ".pdf");
      document.body.appendChild(fileLink);
      fileLink.click();
    },

    async confirmarParametrosConsultaModal(id, parametros) {
      this.exibirModalFiltro = false;
      await this.sleep(100);
      await this.executarRelatorio(id, parametros);
    },

    exibirParametrosConsultaModal(exibir) {
      this.exibirModalFiltro = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_parametros_consulta_relatorio",
          /*open*/ () => {
            this.$utils.requestFocus("kt_modal_parametros_consulta_relatorio");
          },
          /*close*/ () => {
            this.exibirParametrosConsultaModal(false);
          }
        );
      }
    },
  },
  async mounted() {
    this.loading = true;
    this.carregarRelatorios();
    this.loading = false;
  },
  data() {
    return {
      loading: false,
      errosGerais: {},
      relatorios: [],
      pesquisa: "",
      emptyText: "",
      relatorioAtual: null,
      relatorioAberto: null,
      relatoriosAbertos: [],
      mensagemLoading: "",
      loadingExecutarRelatorio: false,
      exibirModalEmail: false,
      emails: [],
      assuntoEmail: "",
      mensagemEmail: "",
      anexosEmail: [],
      mensagemLoadingCarregar: "",
      loadingCarregarRelatorio: false,
      relatorioAtualParametros: null,
      exibirModalFiltro: false,
    };
  },
};
</script>

<style scoped>
.multiline-label {
  white-space: normal;
  line-height: 1;
  margin-top: 10px;
}
.custom-tree-node {
  white-space: normal;
  line-height: 1.3;
}
.custom-tree >>> .el-tree-node__content {
  height: auto;
}

.view-pdf {
  padding: 16px;
  background-color: #ccc;
}
.vue-pdf-embed > div {
  margin-bottom: 8px;
  box-shadow: 0 2px 8px 4px rgba(0, 0, 0, 0.1);
}

.quebra-texto {
  white-space: pre-line;
}

.prevent-select {
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -khtml-user-select: none;
  -ms-user-select: none;
}
</style>
